import http from '../utils/http'
import api from '.'

export function getList(data) {
    // return http.get(api.searchkey.searchkey + '?is_opportunity=' + data.is_opportunity + '&pageIndex='+data.pageIndex + '&pageSize=' + data.pageSize+ '&key='+data.key)
    return http.get(api.searchkey.searchkey,data)
}